import LeadContainers from "../containers/Leads/index";
import React from "react";

const LeadRequest = () => {
  return (
    <>
      <LeadContainers />
    </>
  );
};

export default LeadRequest;